import type { FaireProductEntity } from "../../entity_types/product";

export const p_xrquq6bnnp: FaireProductEntity = {
  token: "p_xrquq6bnnp",
  type: "product",
  name: "Brass Wind Chime with bells and 3 Buddha",
  brandToken: "b_pfe5z89pnk",
  brandName: "Vrinda",
  imageUrl: "https://cdn.faire.com/fastly/8e3b9f4bd09259cfa05028652b0753b28ab324326656ce9f4a76b78799ab441a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/30a092588ebc4bb93f5380cedd981a8360c22c29286d2343ca6be675a4759485.jpeg",
    "https://cdn.faire.com/fastly/d936ee96604c979b5f33ccd70b13727c540ff4668295dcfa70235320d49faa56.jpeg",
    "https://cdn.faire.com/fastly/6a29fce3e553eaadab58c693b092d1bea2b476948a1de9b4038074d8d17c8d5c.jpeg",
    "https://cdn.faire.com/fastly/3e748ef5c7cdbf51729f732fcfad4a682508989db7e8c6523da0665bb8072033.jpeg",
    "https://cdn.faire.com/fastly/b47eb75e2838b73cf66a31094ce7e17f5a47b5b42c788215c49c05b48f895f5c.jpeg"
  ],
  priceDollars: 8.3,
  description: "- Size: Approx. 22 Inches in length, 2\" diameter\n- Design: 3 Buddha",
  tags: [],
  msrpDollars: 16.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:56.088Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
